import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => (state.data && state.data.akun) || {},
      pspConfig: (state) => (state.data && state.data.config) || {},
    }),

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Pilih Provinsi', 'Pilih Kab / Kota'],
        options: [M_PROPINSI, M_KOTA],
        grid: [
          { cols: 12, lg: 6 },
          { cols: 12, lg: 6 },
        ],
        disabled: [],
      };
    },

    formFilter() {
      let filter = [
        {
          label: 'Berdasarkan Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12 },
        },
      ];

      if (this.$route.meta.api === 'pelatih-ahli') {
        filter.push({
          label: 'Berdasarkan Unsur',
          default: true,
          type: 'select',
          model: 'k_unsur_psp',
          master: this.$mapForMaster(this.masters.unsur_psp),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Status Gugur',
          default: true,
          type: 'select',
          model: 'is_gugur',
          master: this.$mapForMaster(this.M_GUGUR),
          props: ['attach', 'chips', 'deletable-chips', 'small-chips'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Status Diskualifikasi',
          default: true,
          type: 'select',
          model: 'is_aktif',
          master: this.$mapForMaster(this.M_DISKUALIFIKASI),
          props: ['attach', 'chips', 'deletable-chips', 'small-chips'],
          grid: { cols: 12, md: 6 },
        });
      } else if (this.$route.meta.api === 'pelaksana') {
        filter.push({
          label: 'Status',
          default: true,
          type: 'select',
          model: 'is_aktif',
          master: this.$mapForMaster(this.M_STATUS),
          props: ['attach', 'chips', 'deletable-chips', 'small-chips'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Kesesuaian dengan Dapodik',
          default: true,
          type: 'select',
          model: 'is_sesuai_dapodik',
          master: this.$mapForMaster(this.M_STATUS_SESUAI),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Riwayat perubahan status',
          default: true,
          type: 'select',
          model: 'is_log',
          master: [
            { text: 'Ada', value: 1 },
            { text: 'Tidak ada', value: 0 },
          ],
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Jenjang',
          default: true,
          type: 'select',
          model: 'k_jenjang',
          master: this.$mapForMaster(this.$getDeepObj(this.masters, 'jenjang')),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Status Negeri/Swasta',
          default: true,
          type: 'select',
          model: 'is_negeri',
          master: [
            { value: '1', text: 'Negeri' },
            { value: '0', text: 'Swasta' },
          ],
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
        filter.push({
          label: 'Pilih Gelombang PKP',
          type: 'select',
          model: 'gelombang_diklat',
          master: [
            { text: 'Gelombang PKP 1', value: 1 },
            { text: 'Gelombang PKP 2', value: 2 },
          ],
          grid: { cols: 12, md: 6 },
        });
      }

      return filter;
    },

    filtersMaster() {
      return {
        k_propinsi: this.masters && this.masters['propinsi'],
        k_kota: this.masters && this.masters['kota'],
        k_unsur_psp: this.masters && this.masters['unsur_psp'],
        is_gugur: this.M_GUGUR,
        is_aktif: this.$route.meta.api === 'pelaksana' ? this.M_STATUS : this.M_DISKUALIFIKASI,
        is_sesuai_dapodik: this.M_STATUS_SESUAI,
        is_log: this.M_STATUS_RIWAYAT,
        is_negeri: this.M_STATUS_NEGERI,
        k_jenjang: this.masters && this.masters['jenjang'],
        gelombang_diklat: { 1: 'Gelombang PKP 1', 2: 'Gelombang PKP 2' },
      };
    },

    mGelombang() {
      let result = [];

      if (this.$route.meta.api === 'pelatih-ahli') {
        result = [{ text: 'Semua Angkatan', value: '' }];
      }

      for (let i = Number(this.pspConfig['peringkat']['gelombang']); i > 0; i--) {
        result.push({ text: `Angkatan ${i}`, value: i });
      }

      return result;
    },
  },
  methods: {
    ...mapActions('diskualifikasi', ['fetch', 'getDetail', 'actions', 'mundur', 'downloadList']),
    ...mapActions('master', ['getMasters']),

    fetchData: function() {
      return new Promise((resolve) => {
        let params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);

        if (!params.gelombang) {
          delete params.gelombang;
        }

        this.fetch({ params, attr }).then(({ data, meta, total, last_page, per_page }) => {
          this.data = data || [];
          this.dataMeta = meta || {};
          this.total = meta?.total || total || data.length || 0;
          this.pageTotal = meta?.last_page || last_page || 1;
          this.params.limit = per_page || this.params.limit;
          this.statistik = meta?.statistik ?? {};
          this.config = meta?.config || {};
          resolve(true);
        });
      });
    },

    allow(action, data) {
      let allow = true;
      const isAktif = +this.$getDeepObj(data, 'is_aktif') === 1;

      switch (action.event) {
        case 'onUndurDiri':
          allow = this.$allow(action.akses) && isAktif;
          break;
        case 'onBatalUndurDiri':
          allow = this.$allow(action.akses) && !isAktif;
          break;
        default:
          allow = this.$allow(action.akses);
          break;
      }

      return allow;
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(this.$getDeepObj(item, 'no_wa'))}`;
      window.open(url, '_blank');
    },

    onClose() {
      if (!this.formulir['autoClose']) {
        const msg = [
          '<h3>Apakah Anda yakin ingin keluar dari halaman ini ?</h3>',
          'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
        ].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      }
    },

    getAdminDiskualifikasi(item) {
      const proseses = this.$getDeepObj(item, 'psp_profil_proseses.data');
      const undur = proseses.filter((item) => item.k_profil_proses_psp === 27)[0] || {};
      return undur;
    },

    addPeserta() {
      this.$set(this.formulir, 'title', 'Tambah Sekolah Peserta');
      this.$set(this.formulir, 'form', 'FormPeserta');
      this.$set(this.formulir, 'jenis', this.jenis);
      this.$set(this.formulir, 'autoClose', false);
      this.$set(this.formulir, 'preview', false);
      this.$set(this.formulir, 'masters', {
        gelombang: (this.mGelombang || []).filter((item) => item.value !== ''),
        kp_kategori_psp: {
          1: 'Kriteria 1 (Model Pendampingan Intensif)',
          2: 'Kriteria 2 (Model Pendampinagn Moderate)',
          3: 'Kriteria 3 (Model Pendampingan Mandiri)',
        },
      });
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onDetailPeserta(item) {
      this.$set(this.formulir, 'title', 'Lihat Detail');
      this.$set(this.formulir, 'form', 'FormStatus');
      this.$set(this.formulir, 'autoClose', true);
      this.$set(this.formulir, 'preview', true);
      this.$set(this.formulir, 'id', item.psp_pelaksana_id);

      this.getDetail({ id: item.psp_pelaksana_id }).then((data) => {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'detail', data);
        });
      });
    },

    async onSetStatusPelaksana(item) {
      this.$set(this.formulir, 'title', 'Set Status');
      this.$set(this.formulir, 'action', 'undur');
      this.$set(this.formulir, 'form', 'FormStatus');
      this.$set(this.formulir, 'autoClose', false);
      this.$set(this.formulir, 'preview', false);
      this.$set(this.formulir, 'id', item.psp_pelaksana_id);
      this.$set(this.formulir, 'jenis', this.$route.meta.api);

      this.getDetail({ id: item.psp_pelaksana_id, jenis: this.jenis, attr: this.attr }).then((data) => {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'detail', data);
        });
      });
    },

    onSetStatus(item) {
      this.onUndurDiri(item);
    },

    async onUndurDiri(item) {
      this.$set(
        this.formulir,
        'title',
        this.$route.meta.api === 'pelatih-ahli' ? 'Set Status' : 'Set Mengundurkan Diri'
      );
      this.$set(this.formulir, 'action', 'undur');
      this.$set(this.formulir, 'form', 'FormAjuan');
      this.$set(this.formulir, 'preview', false);
      this.$set(this.formulir, 'autoClose', false);
      this.$set(this.formulir, 'id', item.psp_profil_id);
      this.$set(this.formulir, 'jenis', this.$route.meta.api);

      this.getDetail({ id: item.psp_profil_id, jenis: this.jenis, attr: this.attr }).then(({ data }) => {
        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'detail', data);
        });
      });
    },

    async onBatalUndurDiri(item) {
      const id = item.psp_profil_id;
      this.$confirm(`Anda yakin ingin membatalkan undur diri Peserta PSP berikut?`, `Batal Undur Diri`, {
        tipe: 'warning',
        data: this.confirmHtml(item),
      }).then(() => {
        this.actions({ id, action: 'batal-mundur' }).then(() => {
          this.$success(`Batal undur diri berhasil`);
          this.onReload();
        });
      });
    },

    onSave() {
      const form = this.formulir.form || '';
      const formulir = this.$refs.formulir.getValue();
      const action = this.formulir.action || '';
      const jenis = this.formulir.jenis;
      const id = this.formulir.id;

      if (form === 'FormPeserta') this.savePeserta({ formulir });
      else if (form === 'FormStatus') this.savePesertaStatus({ formulir, id });
      else this.saveUndur({ formulir, jenis, id, action });
    },

    savePeserta({ formulir }) {
      // validate sekolah_id n ptk_id
      if (!(formulir && formulir.sekolah_id)) {
        this.$error('Instansi Sekolah Penggerak belum dipilih!');
        this.$refs.modal.loading = false;
        return;
      }
      if (!(formulir && formulir.ptk_id)) {
        this.$error('Kepala Sekolah tidak ditemukan!');
        this.$refs.modal.loading = false;
        return;
      }

      this.actions({ action: 'create', params: formulir })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    savePesertaStatus({ formulir, id }) {
      if (formulir.pilihan === 'ganti-kasek' && !(formulir && formulir.ptk_id)) {
        this.$error('Kepala Sekolah Pengganti tidak ditemukan!');
        this.$refs.modal.loading = false;
        return;
      }

      this.actions({ action: formulir.pilihan, id, params: formulir })
        .then(() => {
          this.$success('Aksi Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    saveUndur({ formulir, jenis, id, action }) {
      const title = jenis === 'pelatih-ahli' ? 'Set Status' : 'Set Undur Diri';

      const html = `<span class="subtitle-1">Anda Yakin ingin <strong>${
        action === 'undur' ? title : 'Set Batal Undur Diri'
      }</strong> peserta berikut ?</span>`;

      // validate
      if (jenis === 'pelatih-ahli') {
        const isAktif = formulir.is_aktif;
        if (isAktif === 0 && !formulir.berkas) {
          this.$error('Berkas pendukung tidak ditemukan');
          this.$refs.modal.loading = false;
          return;
        }
        if (isAktif === 0 && !formulir.alasan_diskualifikasi) {
          this.$error('Alasan diskualifikasi belum dipilih');
          this.$refs.modal.loading = false;
          return;
        }
        if (
          isAktif === 0 &&
          formulir.alasan_diskualifikasi === 'Alasan Lainnya' &&
          !formulir.alasan_diskualifikasi_lain
        ) {
          this.$error('Tuliskan Alasan lain diskualifikasi');
          this.$refs.modal.loading = false;
          return;
        }
      } else {
        if (!formulir.berkas) {
          this.$error('Berkas pendukung tidak ditemukan');
          this.$refs.modal.loading = false;
          return;
        }
      }

      const params = new FormData();
      if (jenis === 'pelatih-ahli') {
        params.append('is_aktif', formulir.is_aktif);

        if (formulir.is_aktif === 0) {
          params.append('label', 'undur');
          params.append('file', formulir.berkas);
          params.append(
            'alasan_diskualifikasi',
            formulir.alasan_diskualifikasi === 'Alasan Lainnya'
              ? formulir.alasan_diskualifikasi_lain
              : formulir.alasan_diskualifikasi
          );
        }
      } else {
        params.append('label', 'undur');
        params.append('file', formulir.berkas);
      }

      this.$confirm(html, 'Konfirmasi').then(() => {
        this.$refs.modal.loading = true;
        this.mundur({ id, params, jenis, attr: this.attr })
          .then(() => {
            this.$success('Berhasil disimpan');
            this.$refs.modal.dialog = false;
            this.onReload();
          })
          .catch(() => {
            this.$refs.modal.loading = false;
          });
      });

      this.$refs.modal.loading = false;
    },

    confirmHtml(data) {
      const ptk = this.$getDeepObj(data, 'ptk') || {};
      return [
        {
          icon: 'mdi-account',
          iconSize: 50,
          iconColor: 'secondary',
          title: this.$getDeepObj(ptk, 'data.nama') || '',
          subtitles: [`<span class="text--primary">${this.$getDeepObj(ptk, 'data.no_ukg')}</span>`],
        },
      ];
    },

    downloadLaporan(url) {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});

      this.downloadList({ params, url: url.dokumen, attr: this.attr }).then((url) => {
        this.$downloadFile(url);
      });
    },
  },
};
